import React from "react";

export const getColumns = (sessionData, showStudentName, showLanguage, showTutor=false, showCalender=false, onHandleOpenCalendarModal=null) => {
  const hasRecording = sessionData.some((s) => "recordingLink" in s);
  const columns = []
  if(showTutor) {
    columns.push({ header: "Tutor", accessor: "tutorName" });
  }

  if (showStudentName) {
    columns.push({ header: "Student", accessor: "studentName" });
  }

  // if (showLanguage){
    columns.push({ header: 'Language', accessor: 'subject' })
  // }

  columns.push(
    { 
      header: 'Status', 
      accessor: 'sessionStatus',
      render: (item) => (
        <span
          className={`font-w600 text-${
            item.sessionStatus === "Cancelled"
              ? "danger"
              : item.sessionStatus === "Scheduled" || item.sessionStatus === "Rescheduled"
              ? "warning"
              : item.sessionStatus === "Missed"
              ? "gray"
              : "success"
          }`}
        >
          {item.sessionStatus}
        </span>
      ),
    },
    { 
      header: 'Scheduled Date', 
      accessor: 'scheduledDate',
      render: (session) => new Date(session.scheduledDate).toLocaleDateString()
    },
    { header: 'Scheduled Time', accessor: 'scheduledTime' },
     {
      header: hasRecording ? "Recording Link" : "Meeting Link",
      accessor: hasRecording? "recordingLink" : "meetingLink",
      render: (session) => {
        const link = session.recordingLink || (session.joinMeetingLink || session.meetingLink || session.startMeetingLink);
        return link ? (
        <a href={link} target="_blank" className="text-primary text-decoration-underline" rel="noopener noreferrer">
          {session.recordingLink ? "View Recording" : "Join Meeting"}
        </a>
      ) : (
          'No link available'
      ) 
    },
  }
  );

  if(showCalender) {
    columns.push({
      header: 'Add to Calendar',
      accessor: 'calendar',
      render: (item) => (
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={(e) => {
            e.stopPropagation();
            onHandleOpenCalendarModal(item);
          }}
          title="Add to Calendar"
        >
          <i className="fas fa-calendar-plus me-1"></i>
          Add to Calendar
        </button>
      )
    })
  }
  return columns;
}